export type BorderRadius =
  | '6px'
  | '12px'
  | '16px'
  | '24px'
  | '32px'
  | '40px'
  | '56px'
  | '64px'
  | '80px'
  | '94px'
  | '144px';

export const rtlVariants: Record<BorderRadius, string> = {
  '6px': 'rounded-tl-[6px]',
  '12px': 'rounded-tl-[12px]',
  '16px': 'rounded-tl-[16px]',
  '24px': 'rounded-tl-[24px]',
  '32px': 'rounded-tl-[32px]',
  '40px': 'rounded-tl-[40px]',
  '56px': 'rounded-tl-[56px]',
  '64px': 'rounded-tl-[64px]',
  '80px': 'rounded-tl-[80px]',
  '94px': 'rounded-tl-[94px]',
  '144px': 'rounded-tl-[144px]',
};

export const rtrVariants: Record<BorderRadius, string> = {
  '6px': 'rounded-tr-[6px]',
  '12px': 'rounded-tr-[12px]',
  '16px': 'rounded-tr-[16px]',
  '24px': 'rounded-tr-[24px]',
  '32px': 'rounded-tr-[32px]',
  '40px': 'rounded-tr-[40px]',
  '56px': 'rounded-tr-[56px]',
  '64px': 'rounded-tr-[64px]',
  '80px': 'rounded-tr-[80px]',
  '94px': 'rounded-tr-[94px]',
  '144px': 'rounded-tr-[144px]',
};

export const rblVariants: Record<BorderRadius, string> = {
  '6px': 'rounded-bl-[6px]',
  '12px': 'rounded-bl-[12px]',
  '16px': 'rounded-bl-[16px]',
  '24px': 'rounded-bl-[24px]',
  '32px': 'rounded-bl-[32px]',
  '40px': 'rounded-bl-[40px]',
  '56px': 'rounded-bl-[56px]',
  '64px': 'rounded-bl-[64px]',
  '80px': 'rounded-bl-[80px]',
  '94px': 'rounded-bl-[94px]',
  '144px': 'rounded-bl-[144px]',
};

export const rbrVariants: Record<BorderRadius, string> = {
  '6px': 'rounded-br-[6px]',
  '12px': 'rounded-br-[12px]',
  '16px': 'rounded-br-[16px]',
  '24px': 'rounded-br-[24px]',
  '32px': 'rounded-br-[32px]',
  '40px': 'rounded-br-[40px]',
  '56px': 'rounded-br-[56px]',
  '64px': 'rounded-br-[64px]',
  '80px': 'rounded-br-[80px]',
  '94px': 'rounded-br-[94px]',
  '144px': 'rounded-br-[144px]',
};

export const rtlVariantsTablet: Record<BorderRadius, string> = {
  '6px': 'md:rounded-tl-[6px]',
  '12px': 'md:rounded-tl-[12px]',
  '16px': 'md:rounded-tl-[16px]',
  '24px': 'md:rounded-tl-[24px]',
  '32px': 'md:rounded-tl-[32px]',
  '40px': 'md:rounded-tl-[40px]',
  '56px': 'md:rounded-tl-[56px]',
  '64px': 'md:rounded-tl-[64px]',
  '80px': 'md:rounded-tl-[80px]',
  '94px': 'md:rounded-tl-[94px]',
  '144px': 'md:rounded-tl-[144px]',
};

export const rtrVariantsTablet: Record<BorderRadius, string> = {
  '6px': 'md:rounded-tr-[6px]',
  '12px': 'md:rounded-tr-[12px]',
  '16px': 'md:rounded-tr-[16px]',
  '24px': 'md:rounded-tr-[24px]',
  '32px': 'md:rounded-tr-[32px]',
  '40px': 'md:rounded-tr-[40px]',
  '56px': 'md:rounded-tr-[56px]',
  '64px': 'md:rounded-tr-[64px]',
  '80px': 'md:rounded-tr-[80px]',
  '94px': 'md:rounded-tr-[94px]',
  '144px': 'md:rounded-tr-[144px]',
};

export const rblVariantsTablet: Record<BorderRadius, string> = {
  '6px': 'md:rounded-bl-[6px]',
  '12px': 'md:rounded-bl-[12px]',
  '16px': 'md:rounded-bl-[16px]',
  '24px': 'md:rounded-bl-[24px]',
  '32px': 'md:rounded-bl-[32px]',
  '40px': 'md:rounded-bl-[40px]',
  '56px': 'md:rounded-bl-[56px]',
  '64px': 'md:rounded-bl-[64px]',
  '80px': 'md:rounded-bl-[80px]',
  '94px': 'md:rounded-bl-[94px]',
  '144px': 'md:rounded-bl-[144px]',
};

export const rbrVariantsTablet: Record<BorderRadius, string> = {
  '6px': 'md:rounded-br-[6px]',
  '12px': 'md:rounded-br-[12px]',
  '16px': 'md:rounded-br-[16px]',
  '24px': 'md:rounded-br-[24px]',
  '32px': 'md:rounded-br-[32px]',
  '40px': 'md:rounded-br-[40px]',
  '56px': 'md:rounded-br-[56px]',
  '64px': 'md:rounded-br-[64px]',
  '80px': 'md:rounded-br-[80px]',
  '94px': 'md:rounded-br-[94px]',
  '144px': 'md:rounded-br-[144px]',
};

export const rtlVariantsDesktop: Record<BorderRadius, string> = {
  '6px': 'lg:rounded-tl-[6px]',
  '12px': 'lg:rounded-tl-[12px]',
  '16px': 'lg:rounded-tl-[16px]',
  '24px': 'lg:rounded-tl-[24px]',
  '32px': 'lg:rounded-tl-[32px]',
  '40px': 'lg:rounded-tl-[40px]',
  '56px': 'lg:rounded-tl-[56px]',
  '64px': 'lg:rounded-tl-[64px]',
  '80px': 'lg:rounded-tl-[80px]',
  '94px': 'lg:rounded-tl-[94px]',
  '144px': 'lg:rounded-tl-[144px]',
};

export const rtrVariantsDesktop: Record<BorderRadius, string> = {
  '6px': 'lg:rounded-tr-[6px]',
  '12px': 'lg:rounded-tr-[12px]',
  '16px': 'lg:rounded-tr-[16px]',
  '24px': 'lg:rounded-tr-[24px]',
  '32px': 'lg:rounded-tr-[32px]',
  '40px': 'lg:rounded-tr-[40px]',
  '56px': 'lg:rounded-tr-[56px]',
  '64px': 'lg:rounded-tr-[64px]',
  '80px': 'lg:rounded-tr-[80px]',
  '94px': 'lg:rounded-tr-[94px]',
  '144px': 'lg:rounded-tr-[144px]',
};

export const rblVariantsDesktop: Record<BorderRadius, string> = {
  '6px': 'lg:rounded-bl-[6px]',
  '12px': 'lg:rounded-bl-[12px]',
  '16px': 'lg:rounded-bl-[16px]',
  '24px': 'lg:rounded-bl-[24px]',
  '32px': 'lg:rounded-bl-[32px]',
  '40px': 'lg:rounded-bl-[40px]',
  '56px': 'lg:rounded-bl-[56px]',
  '64px': 'lg:rounded-bl-[64px]',
  '80px': 'lg:rounded-bl-[80px]',
  '94px': 'lg:rounded-bl-[94px]',
  '144px': 'lg:rounded-bl-[144px]',
};

export const rbrVariantsDesktop: Record<BorderRadius, string> = {
  '6px': 'lg:rounded-br-[6px]',
  '12px': 'lg:rounded-br-[12px]',
  '16px': 'lg:rounded-br-[16px]',
  '24px': 'lg:rounded-br-[24px]',
  '32px': 'lg:rounded-br-[32px]',
  '40px': 'lg:rounded-br-[40px]',
  '56px': 'lg:rounded-br-[56px]',
  '64px': 'lg:rounded-br-[64px]',
  '80px': 'lg:rounded-br-[80px]',
  '94px': 'lg:rounded-br-[94px]',
  '144px': 'lg:rounded-br-[144px]',
};

export const radiusVariants: Record<BorderRadius, string> = {
  '6px': 'rounded-[6px]',
  '12px': 'rounded-[12px]',
  '16px': 'rounded-[16px]',
  '24px': 'rounded-[24px]',
  '32px': 'rounded-[32px]',
  '40px': 'rounded-[40px]',
  '56px': 'rounded-[56px]',
  '64px': 'rounded-[64px]',
  '80px': 'rounded-[80px]',
  '94px': 'rounded-[94px]',
  '144px': 'rounded-[144px]',
};

export const radiusVariantsTablet: Record<BorderRadius, string> = {
  '6px': 'md:rounded-[6px]',
  '12px': 'md:rounded-[12px]',
  '16px': 'md:rounded-[16px]',
  '24px': 'md:rounded-[24px]',
  '32px': 'md:rounded-[32px]',
  '40px': 'md:rounded-[40px]',
  '56px': 'md:rounded-[56px]',
  '64px': 'md:rounded-[64px]',
  '80px': 'md:rounded-[80px]',
  '94px': 'md:rounded-[94px]',
  '144px': 'md:rounded-[144px]',
};

export const radiusVariantsDesktop: Record<BorderRadius, string> = {
  '6px': 'lg:rounded-[6px]',
  '12px': 'lg:rounded-[12px]',
  '16px': 'lg:rounded-[16px]',
  '24px': 'lg:rounded-[24px]',
  '32px': 'lg:rounded-[32px]',
  '40px': 'lg:rounded-[40px]',
  '56px': 'lg:rounded-[56px]',
  '64px': 'lg:rounded-[64px]',
  '80px': 'lg:rounded-[80px]',
  '94px': 'lg:rounded-[94px]',
  '144px': 'lg:rounded-[144px]',
};
